import React, { useEffect, useMemo , useState } from "react";
export function SelectSearch({
  options,
  disabled,
  changed,
  placeholder,
  flags,
  defaultValue,
}) {
  const [locked, setLocked] = useState(false);
  const [show, setShow] = useState(false);
  const [dirty, setDirty] = useState(false);
  const [search, setSearch] = useState("");
  const [showOptions, setShowOptions] = useState([]);
  const inputName = useMemo(() => crypto.randomUUID(), []);

  const autoSelect = (valueSearch) => {
    if (valueSearch?.length > 0 ) {
      const newSearch = valueSearch.replace('0','').toLowerCase()
      const regex = new RegExp(newSearch, "i");
      let aut = options.find(s => s.value== newSearch );
      if (!aut){
         aut = options.find(s => regex.test(String(s.value)));
      }
      if(aut){
        selectItem(aut);
      }else{
        setSearch("");
      }
    }
  };

  const clearOption = () => {
    setLocked(false);
    setShow(false);
    setDirty(false);
    setSearch("");
    changed(null);
  };

  const selectItem = (option) => {
    setLocked(true);
    setDirty(true);
    setShow(false);
    setSearch(option.value);
    changed(option);
  };

  useEffect(() => {
    setShowOptions(options);
  }, [options]);

  useEffect(() => {
    if (typeof defaultValue == "string") {
      const find = options.find((op) => op.value == defaultValue);
      if (find) {
        selectItem(find);
      }
    }
  }, [defaultValue]);

  useEffect(() => {
    if (typeof search == "string" && !locked) {
      const filteredOptions = options
        ?.filter((option) =>
          option?.label
            .replace("-", "")
            .replace("  ", " ")
            ?.toLowerCase()
            .includes(search?.toLowerCase())
        )
        .slice(0, 60);
      setShowOptions(filteredOptions);
    }
  }, [search]);

  return (
    <div className="select-search-wrapper">
      <input
        type="text"
        name={inputName}
        id={inputName}
        autoComplete="off"
        placeholder={placeholder}
        className={`select-search-input ${disabled ? "disabled" : "enabled"}`}
        value={search}
        onBlur={(e)=>{
          autoSelect(e.target?.value ??"")
        }}
        onFocus={() => {
          setShow(true);
        }}
        onChange={(event) => {
          setSearch(event?.target?.value ?? "");
          setShow(true);
        }}
        disabled={locked || disabled}
      />
      {locked && (
        <button type="button" className="clear-button" onClick={clearOption}>
          ✕
        </button>
      )}
      {show && showOptions?.length > 0 && (
        <div className="select-search-dropdown">
          <div>
            {showOptions.map((op, index) => (
              <button
                key={index}
                className="select-search-dropdown-item"
                onMouseDown={(e) => {
                  e.preventDefault(); 
                  selectItem(op);
                  setShow(false);
                }}

                onClick={() => {
                  selectItem(op);
                  setShow(false);
                }}
              >
                {op.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
